import { useState, useEffect, useMemo, useRef } from "react";
import { useGlobalContext } from "../Config";
import { useLocation } from "react-router-dom";
import { Button } from "primereact/button";

import FormCrearDocumento from "../components/FormCrearDocumento";
import FormSubirPdfDocumento from "../components/FormSubirPdfDocumento";
import FormEditarDocumento from "../components/FormEditarDocumento";
import FormSubirDocumentoFinal from "../components/FormSubirDocumentoFinal";
import DocumentosTreeTable from "../components/DocumentosTreeTable";
import { NodeService } from '../service/NodeService'
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import Loader from "../components/Loader.js";
import TablePlantillas from "../components/TablePlantillas.js";

const Documentos = () => {
  const location = useLocation();
  const toast = useRef(null);
  const [treeNodes, setTreeNodes] = useState([]);
  const [treeTableNodes, setTreeTableNodes] = useState([]);
  const [selectedTreeTableNodeKeys, setSelectedTreeTableNodeKeys] = useState([]);
  const { baseUrl, urlContratos } = useGlobalContext();

  const [isFormVisibleEditPlantilla, setIsFormVisibleEditPlantilla] = useState(false);
  const [isFormVisibleSave, setIsFormVisibleSave] = useState(false);
  const [isFormVisibleSavePdf, setIsFormVisibleSavePdf] = useState(false);
  const [isFormVisibleEdit, setIsFormVisibleEdit] = useState(false);
  const [isFormVisibleUploadFinal, setIsFormVisibleUploadFinal] = useState(false);
  const [selectedDocumentoId, setSelectedDocumentoId] = useState('');
  const [selectedDocumentoVariablesJson, setSelectedDocumentoVariablesJson] = useState('');
  const [selectedDocumentoMetadataJson, setSelectedDocumentoMetadataJson] = useState('');
  const [idEstadoDocumento, setIdEstadoDocumento] = useState('');
  const [selectedFilename, setSelectedFilename] = useState('');
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState('');
  const [contratoSeleccionado, setContratoSeleccionado] = useState('');
  const [idEmpresaSeleccionada, setIdEmpresaSeleccionada] = useState('');
  const [idClienteSeleccionado, setIdClienteSeleccionado] = useState('');
  const [idCotizacionSeleccionada, setIdCotizacionSeleccionada] = useState('');
  const [loading, setLoading] = useState(false);
  const [razonSocial, setRazonSocial] = useState('');
  const [selectedIdContrato, setSelectedIdContrato] = useState('');
  const [selectedIdTipoDocumento, setSelectedIdTipoDocumento] = useState('');
  
  useEffect(() => {
      const nodeService = new NodeService();
      nodeService.getTreeNodes().then((data) => setTreeNodes(data));
      // (quitado) nodeService.getTreeTableNodes(); usamos servicio real
  }, []);


  const toggleFormVisibilityEditPlantilla = () => {
    if (isFormVisibleEditPlantilla) {
      setIsFormVisibleEditPlantilla(false);
    } else {
      setIsFormVisibleEditPlantilla(true);
    }
  };

  const toggleFormVisibilitySave = (empresa, idContrato, idEmpresa, idCliente, razonSocial, idCotizacion) => {
    setEmpresaSeleccionada(empresa ?? '');
    setContratoSeleccionado(idContrato ?? '');
    setIdEmpresaSeleccionada(idEmpresa ?? '');
    setIdClienteSeleccionado(idCliente ?? '');
    setRazonSocial(razonSocial ?? '');
    setIdCotizacionSeleccionada(idCotizacion ?? '');
    setIsFormVisibleSave(!isFormVisibleSave);
  };

  const toggleFormVisibilitySavePdf = (idContrato, empresa) => {
    // Antes: sólo seteaba si todos los campos eran truthy, lo que bloqueaba con valores 0/null
    setContratoSeleccionado(idContrato ?? '');
    setEmpresaSeleccionada(empresa ?? '');
    setIsFormVisibleSavePdf(!isFormVisibleSavePdf);
  };

  const toggleFormVisibilityEdit = (idDocumento, variablesJson, metadataJson, fileName, idEstadoDocumento) => {
    setSelectedDocumentoId(idDocumento);
    setSelectedDocumentoVariablesJson(variablesJson);
    setSelectedDocumentoMetadataJson(metadataJson);
    setSelectedFilename(fileName);
    setIdEstadoDocumento(idEstadoDocumento);
    setIsFormVisibleEdit(!isFormVisibleEdit);
  };

  const toggleFormVisibilityUploadFinal = (idDocumento, idContrato, idTipoDocumento) => {
    setSelectedDocumentoId(idDocumento);
    setSelectedIdContrato(idContrato);
    setSelectedIdTipoDocumento(idTipoDocumento);
    setIsFormVisibleUploadFinal(!isFormVisibleUploadFinal);
  };

  const handleRescatarDocumento = async (idDocumento, fileName) => {
    try {
        const resp = await fetch(`${urlContratos}rescatarDocumento?id=${encodeURIComponent(idDocumento)}`,
        {
            method: 'GET',
            credentials: 'include',
        }
      );
        if (!resp.ok) throw new Error(`Error al rescatar documento (${resp.status})`);
        const blob = await resp.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName ;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (err) {
        console.error('No se pudo descargar el documento:', err);
    }
  };

  const handleRescatarDocumentoFinal = async (idDocumento, fileName) => {
    try {
        const resp = await fetch(`${urlContratos}rescatarDocumentoPdf?id=${encodeURIComponent(idDocumento)}`,
        {
            method: 'GET',
            credentials: 'include',
        }
      );
        if (!resp.ok) throw new Error(`Error al rescatar documento (${resp.status})`);
        const blob = await resp.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName ;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (err) {
        console.error('No se pudo descargar el documento:', err);
    }
  };

  const handleAnularDocumentoFinal = async (idDocumento) => {
    try {
      const idUsuario = sessionStorage.getItem('usuario_id');
      await fetch(`${urlContratos}anularDocumentoPdf?id=${encodeURIComponent(idDocumento)}&idUsuario=${idUsuario}`,
        {
            method: 'PUT',
            credentials: 'include',
        }
      );
      fetchDocumentos();
    } catch (err) {
        console.error('No se pudo anular el documento:', err);
    }
  };

  const handleAnularDocumento = async (idDocumento) => {
    try {
      const idUsuario = sessionStorage.getItem('usuario_id');
      await fetch(`${urlContratos}anularDocumento?id=${encodeURIComponent(idDocumento)}&idUsuario=${idUsuario}`,
        {
            method: 'PUT',
            credentials: 'include',
        }
      );
      fetchDocumentos();
    } catch (err) {
        console.error('No se pudo anular el documento:', err);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const fetchDocumentos = async () => {
    try {
        setLoading(true);
        // 1) Cotizaciones (asignaciones)
        const response_asignaciones = await fetch(
          `${baseUrl}getCotizacionesByEstados?idUsuario=1&estados=5`,
          {
            method: 'GET',
            headers: new Headers(),
            redirect: 'follow',
            credentials: 'include',
          }
        );
        const asignacionesJson = await response_asignaciones.json();
        const cotizaciones = Array.isArray(asignacionesJson?.cotizaciones)
          ? asignacionesJson.cotizaciones
          : [];

        // Mapa: id_contrato -> datos de cotización que necesitamos para el TreeTable
        const cotizacionesByContratoId = new Map();
        cotizaciones.forEach((c) => {
          const idContrato = c?.contrato?.id_contrato;
          if (!idContrato) return;

          cotizacionesByContratoId.set(idContrato, {
            idCliente: c?.cliente?.id ?? null,
            razonSocial: c?.cliente?.razonSocial ?? '',
            idContrato: idContrato,
            idCotizacion: c?.id ?? null,
            folio: c?.folio ?? null,
            idEmpresaArrendadora: undefined,
            nombreEmpresa: c?.empresa ?? '',
            fechaInicio: c?.desde ?? null,
            fechaTermino: c?.hasta ?? null,
            fechaCreacionContrato: c?.contrato?.fecha_creacion_contrato ?? null,
          });
        });


        // 2) Documentos por contrato
        const response_contratos = await fetch(`${urlContratos}getAllDocumentos`, {
          method: 'GET',
          headers: new Headers(),
          redirect: 'follow',
          credentials: 'include',
        });
        const documentosJson = await response_contratos.json();
        const contratosDocs = Array.isArray(documentosJson?.contratos)
          ? documentosJson.contratos
          : [];
        const contratosDocsById = new Map(
          contratosDocs.map((cd) => [cd.id_contrato, cd])
        );

        // 3) Armar clientes -> contratos -> documentos (match por id_contrato)
        const clientesMap = new Map();

        cotizaciones.forEach((c) => {
          const idContrato = c?.contrato?.id_contrato;
          const idEmpresa = c?.contrato?.id_empresa;
          if (!idContrato) return;

          const cotMeta = cotizacionesByContratoId.get(idContrato);
          const docsInfo = contratosDocsById.get(idContrato);

          const idCliente = cotMeta?.idCliente ?? c?.cliente?.id ?? null;
          const razonSocial = cotMeta?.razonSocial ?? c?.cliente?.razonSocial ?? '';

          if (!clientesMap.has(idCliente)) {
            clientesMap.set(idCliente, {
              id_cliente: idCliente,
              razon_social: razonSocial,
              contratos: [],
            });
          }

          const clienteEntry = clientesMap.get(idCliente);

          // Evitar duplicados de contrato por cliente
          const existingIdx = clienteEntry.contratos.findIndex(
            (ct) => ct.id_contrato === idContrato
          );

          const contratoMerged = {
            id_contrato: idContrato,
            id_cotizacion: cotMeta?.idCotizacion ?? null,
            folio: cotMeta?.folio ?? null,
            nombre_empresa: cotMeta?.nombreEmpresa || docsInfo?.nombre_empresa || '',
            id_empresa: idEmpresa,
            fecha_inicio: cotMeta?.fechaInicio || null,
            fecha_termino: cotMeta?.fechaTermino || null,
            fecha_creacion_contrato: cotMeta?.fechaCreacionContrato || null,
            documentos: Array.isArray(docsInfo?.documentos) ? docsInfo.documentos : [],
          };

          if (existingIdx >= 0) {
            clienteEntry.contratos[existingIdx] = contratoMerged;
          } else {
            clienteEntry.contratos.push(contratoMerged);
          }
        });

        const clientes = Array.from(clientesMap.values());

        // 4) Mapeo para TreeTable (se mantiene tu estructura)
  const groupedNodes = clientes.map((cliente) => ({
    key: `cliente-${cliente.id_cliente ?? cliente.razon_social}`,
    data: {
      name: cliente.razon_social || '',
      tipo: '',
      estado: '',
    },
    children: (cliente.contratos || []).map((contrato, cIdx) => ({
      key: `contrato-${contrato.id_contrato ?? `${cliente.id_cliente}-${cIdx}`}`,
      data: {
        name: `${contrato.id_cotizacion ? `Asignación Nro.° ${contrato.id_cotizacion}. Folio (${contrato.folio})` : ''}`,
        tipo: contrato.nombre_empresa || '',
        empresa: contrato.nombre_empresa || '',
        estado:
          Array.isArray(contrato.documentos) && contrato.documentos.length > 0 ? (
            <Button
              icon="pi pi-check"
              className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
              outlined
              tooltip="Incluye documentos"
              tooltipOptions={{ position: 'top' }}

            />
          ) : (
            <Button
              icon="pi pi-times"
              className="p-button-rounded p-button-secondary p-button mr-2 mb-2 mt-2"
              outlined
              tooltip="Sin Documentos"
              tooltipOptions={{ position: 'top' }}
            />
          ),
        id_contrato: contrato.id_contrato,
        id_cotizacion: contrato.id_cotizacion,
        id_empresa: contrato.id_empresa,
        id_cliente: cliente.id_cliente,
        razon_social: cliente.razon_social,
        fechas: `${formatDate(contrato.fecha_inicio)} - ${formatDate(contrato.fecha_termino)}`,
      },
      children: (contrato.documentos || []).map((doc, dIdx) => {
        const isFinalAtLevel =
          Boolean(doc?.id_documento_final) &&
          (!doc?.id_documento || doc?.es_documento_final_suelto === true);

        if (isFinalAtLevel) {
          // Documento final suelto en el nivel de documentos (sin documento base)
          return {
            key: doc.id_documento_final
              ? `final-${doc.id_documento_final}`
              : `final-${contrato.id_contrato ?? `${cliente.id_cliente}-${cIdx}`}-${dIdx}`,
            data: {
              name: doc.filename_final || doc.tipo_documento || 'Documento Final',
              tipo: `${doc.tipo_documento || 'Documento Final'}. Versión: ${(doc.version_final?.split('-')[1]) || '-'}`,
              estado: 'Final',
              id_documento_final: doc.id_documento_final || '',
              filename_final: doc.filename_final || '',
              version_final: doc.version_final || '',
              fecha_creacion_documento_final: doc.fecha_creacion_documento_final || '',
              actualizacion: doc.fecha_creacion_documento_final || '',
            },
            children: [],
          };
        }

        // Documento no final (base), con posibles finales asociados en doc.final
        return {
          key: doc.id_documento
            ? `doc-${doc.id_documento}`
            : `doc-${contrato.id_contrato ?? `${cliente.id_cliente}-${cIdx}`}-${dIdx}`,
          data: {
            name: doc.filename || doc.tipo_documento || 'Documento',
            tipo: `${doc.tipo_documento || 'Documento'}. Versión (${(doc.version?.split('-')[1]) || '-'})`,
            estado: doc.estado_documento || '',
            id_documento: doc.id_documento || '',
            id_contrato: contrato.id_contrato,
            id_tipo_documento: doc.id_tipo_documento || '',
            variables_json: doc.variables_json || '',
            metadata_json: doc.metadata_json || '',
            filename: doc.filename || '',
            id_estado_documento: doc.id_estado_documento || '',
            actualizacion: doc.fecha_actualizacion_documento,
          },
          children: (doc.final || []).map((fin, fIdx) => ({
            key: fin.id_documento_final
              ? `final-${fin.id_documento_final}`
              : `final-${doc.id_documento ?? `${contrato.id_contrato}-${dIdx}`}-${fIdx}`,
            data: {
              name: fin.filename_final || 'Documento Final',
              tipo: `${doc.tipo_documento || 'Documento Final'}. Versión (${(fin.version_final?.split('-')[1]) || '-'})`,
              estado: 'Final',
              id_documento_final: fin.id_documento_final || '',
              filename_final: fin.filename_final || '',
              version_final: fin.version_final || '',
              fecha_creacion_documento_final: fin.fecha_creacion_documento_final || '',
              actualizacion: fin.fecha_creacion_documento_final || '',
            },
            children: [],
          })),
        };
      }),
    })),
  }));
        setTreeTableNodes(groupedNodes);
    } catch (error) {
        console.error('Error al cargar documentos:', error);
        setTreeTableNodes([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocumentos();
  }, [urlContratos]);

  // Buscador por cliente (filtra nodos raíz)
  const [clienteSearch, setClienteSearch] = useState("");
  useEffect(() => {
    const st = location?.state;
    if (st && typeof st.cliente === "string") {
      setClienteSearch(st.cliente);
    }
  }, [location]);
  const filteredTreeTableNodes = useMemo(() => {
    const q = clienteSearch.trim().toLowerCase();
    if (!q) return treeTableNodes;
    return treeTableNodes.filter(
      (node) => (node.data?.name || "").toLowerCase().includes(q)
    );
  }, [treeTableNodes, clienteSearch]);

  const renderHeader = () => (
    <>
      <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2">
        <span className="p-input-icon-left" style={{ display: "flex", alignItems: "center" }}>
          <i className="pi pi-search" />
          <InputText
            value={clienteSearch}
            onChange={(e) => setClienteSearch(e.target.value)}
            placeholder="Buscar por Cliente..."
          />
        </span> 

        <span className="p-input-icon-left ml-2" style={{ display: "flex", alignItems: "center" }}>
          {filteredTreeTableNodes.length} Clientes
        </span>
        <span className="p-input-icon-left ml-2" style={{ display: "flex", alignItems: "center" }}>
          {filteredTreeTableNodes.reduce((acc, node) => acc + node.children?.length || 0, 0)} Asignaciones
        </span>
        <span className="p-input-icon-left ml-2" style={{ display: "flex", alignItems: "center" }}>
          {filteredTreeTableNodes.reduce((acc, node) => acc + node.children?.reduce((acc2, child) => acc2 + child.children?.length || 0, 0) || 0, 0)} Documentos
        </span>
      </div>
    </>
  );

  return (
    <div className="grid">
      <div className="col-12">
        <div className="card">
          <h4 style={{ marginBottom: "5px" }}>Documentos</h4>
          <h6 style={{ marginTop: "5px" }}>¿Qué documentos se han generado en la plataforma?</h6>
        </div>
      </div>

      <div className="col-12">
          <div className="card">
            <>
              {loading ? (
                <>
                  <Loader />
                </>
              ) : (
                <>
                  
                  <Button 
                    label="Mantenedor de Plantillas"
                    icon="pi pi-pencil"
                    onClick={toggleFormVisibilityEditPlantilla}
                    className="p-button p-component mr-2 p-button-rounded p-button-primary"
                    disabled={loading}
                    raised
                  />
                
                  <DocumentosTreeTable
                      value={filteredTreeTableNodes}
                      header={renderHeader()}
                      selectedKeys={selectedTreeTableNodeKeys}
                      onSelectionChange={setSelectedTreeTableNodeKeys}
                      onDownload={handleRescatarDocumento}
                      onDownloadFinal={handleRescatarDocumentoFinal}
                      onCreateDoc={toggleFormVisibilitySave}
                      onUploadPdf={toggleFormVisibilitySavePdf}
                      onEditDoc={toggleFormVisibilityEdit}
                      onUploadFinal={toggleFormVisibilityUploadFinal}
                      onDelete={handleAnularDocumento}
                      onDeleteFinal={handleAnularDocumentoFinal}
                  />
                </>
              )}
            </>
          </div>
      </div>

      {/* Pop-up para el formulario */}


      <FormCrearDocumento
        isFormVisible={isFormVisibleSave}
        setIsFormVisible={setIsFormVisibleSave}
        empresa={empresaSeleccionada}
        setEmpresa={setEmpresaSeleccionada}
        idContrato={contratoSeleccionado}
        setIdContrato={setContratoSeleccionado}
        idEmpresa={idEmpresaSeleccionada}
        setIdEmpresa={setIdEmpresaSeleccionada}
        idCliente={idClienteSeleccionado}
        setIdCliente={setIdClienteSeleccionado}
        razonSocial={razonSocial}
        setRazonSocial={setRazonSocial}
        idCotizacion={idCotizacionSeleccionada}
        setIdCotizacion={setIdCotizacionSeleccionada}
        fetchDocumentos={fetchDocumentos}
        toast={toast}
      />

      <FormEditarDocumento
        isFormVisible={isFormVisibleEdit}
        setIsFormVisible={setIsFormVisibleEdit}
        toggleFormVisibility={toggleFormVisibilityEdit}
        idDocumento={selectedDocumentoId}
        idEstadoDocumento={idEstadoDocumento}
        fileName={selectedFilename}
        variablesJson={selectedDocumentoVariablesJson}
        metadataJson={selectedDocumentoMetadataJson}
        fetchDocumentos={fetchDocumentos} 
        toast={toast}
      />

      <FormSubirDocumentoFinal
        isFormVisible={isFormVisibleUploadFinal}
        setIsFormVisible={setIsFormVisibleUploadFinal}
        idDocumento={selectedDocumentoId}
        idContrato={selectedIdContrato}
        idTipoDocumento={selectedIdTipoDocumento}
        fetchDocumentos={fetchDocumentos} 
      />

      <FormSubirPdfDocumento
        isFormVisible={isFormVisibleSavePdf}
        setIsFormVisible={setIsFormVisibleSavePdf}
        idContrato={contratoSeleccionado}
        fetchDocumentos={fetchDocumentos} 
        empresa={empresaSeleccionada}
        toast={toast}
      />

      <TablePlantillas
        isFormVisibleEditPlantilla={isFormVisibleEditPlantilla}
        setIsFormVisibleEditPlantilla={setIsFormVisibleEditPlantilla}
      />

      <Toast ref={toast} />
    </div>
  );
};
export default Documentos;


